export class VTotauxFormationsAvisAdmission {
    constructor(
        public idDiplome?: number,
        public diplome?: string,
        public nombrePlaces?: number,
        public totalCandidatures?: number,
        public totalAvisFavorable?: number,
        public avisFavorablePrimo?: number,
        public avisFavorableReinscription?: number,
        public avisFavorablePrimoHe?: number,
        public totalAvisDefavorable?: number,
        public totalAvisLc?: number,
        public avisLcPrimo?: number,
        public avisLcReinscription?: number,
        public avisLcHe?: number,
        public totalAvisReserve?: number,
        public avisNonRenseigne?: number,
        public totalAdmis?: number,
        public admisPrimo?: number,
        public admisReinscription?: number,
        public admisHe?: number,
        public totalLc?: number,
        public lcPrimo?: number,
        public lcReinscription?: number,
        public lcPrimoHe?: number,
        public totalRefuse?: number,
        public admissionNonRenseigne?: number
    ) {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/v-totaux-formations-avis-admission.model.ts